import { render } from "./TwoFactorForm.html?vue&type=template&id=c5e657b8&scoped=true&ts=true&external"
import script from "./TwoFactorForm.vue?vue&type=script&lang=ts"
export * from "./TwoFactorForm.vue?vue&type=script&lang=ts"

import "./TwoFactorForm.scss?vue&type=style&index=0&id=c5e657b8&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5e657b8"]])

export default __exports__